module.exports = __webpack_public_path__ + "static/img/3658_phase_function_Paper_PointsHejduk_Prediction.93a69be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3658_phase_function_Paper_PointsHejduk_Prediction.png
// module id = B8yn
// module chunks = 0